import {
  colors,
  ModalHeader,
  Typography,
  Stack,
  ControlledInput,
  ModalActions,
  Button,
  Input,
} from '@ui-components/neo.tax';
import { ReactComponent as UsersIcon } from '@ui-components/neo.tax/dist/icons/users.svg';
import React from 'react';

import { useProfileEdit } from './hooks/useProfileEdit';
import { StyledProfileEditModal } from './profile-edit-modal.styled';

interface ProfileEditModalProps {
  userId: string;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

export const ProfileEditModal = ({ isOpen, setIsOpen, userId }: ProfileEditModalProps): React.ReactElement => {
  const {
    control,
    formState,
    handleSubmit,
    isLoading,
    onSubmit,
    updateProfileFullNameAnalyticId,
    user,
    validateFullName,
  } = useProfileEdit({
    userId,
    onSuccess: () => setIsOpen(false),
  });

  const handleClose = (): void => {
    setIsOpen(false);
  };

  return (
    <StyledProfileEditModal isOpen={isOpen} setIsOpen={setIsOpen}>
      <Stack as="form" direction="column" gap={2} onSubmit={handleSubmit(onSubmit)}>
        <ModalHeader
          icon={<UsersIcon width={24} color={colors.blue[600]} />}
          iconBgColor={colors.blue[50]}
          title={
            <Typography fontSize="xl" fontWeight="medium">
              Profile Settings
            </Typography>
          }
        />
        <Stack direction="column">
          <ControlledInput
            control={control}
            name="fullName"
            rules={{ required: true, validate: validateFullName }}
            id="fullName"
            label="Full Name"
            placeholder="Enter your full name"
            disabled={isLoading}
          />
          <Input value={user?.email} disabled />
        </Stack>

        <ModalActions hasTopBorder={false}>
          <Button variant="white" rounded="regular" size="base" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            rounded="regular"
            size="base"
            type="submit"
            disabled={!formState.isValid || isLoading}
            id={updateProfileFullNameAnalyticId}
          >
            {isLoading ? 'Updating...' : 'Update Profile'}
          </Button>
        </ModalActions>
      </Stack>
    </StyledProfileEditModal>
  );
};
